module.exports = __webpack_public_path__ + "static/media/floppy-disk.25af6289.svg";